module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../node_modules/esbuild-loader/dist/index.js??ruleSet[1].rules[1]!./bootstrap.tsx"));
	});
}